import { TableCursorPaginationV2 } from '@components/TableV2/TableCursorPaginationV2';
import { useI18n } from '@hooks/useI18n/useI18n';
import { IUuid } from '@schemas/merchantPortal/types/merchantStores';
import { TableNames } from '@utils/constants';
import { useGetMerchantReceivablesTableConfig } from './useGetMerchantReceivablesTableConfig';

interface IMerchantReceivablesTable {
  merchantUuid: IUuid;
}
export const MerchantReceivables = ({
  merchantUuid,
}: IMerchantReceivablesTable) => {
  const { translate } = useI18n();

  const {
    columns,
    data: merchantReceivablesData,
    error,
    filtersSettings,
    isLoading,
    paginationSettings,
    sortingSettings,
  } = useGetMerchantReceivablesTableConfig({ merchantUuid, translate });

  return (
    <TableCursorPaginationV2
      columns={columns}
      count={merchantReceivablesData?.count ?? 10}
      data={merchantReceivablesData?.results ?? []}
      error={error}
      filterSettings={filtersSettings}
      isInTab={true}
      isLoading={isLoading}
      name={TableNames.MERCHANT_RECEIVABLES}
      paginationSettings={paginationSettings}
      sortingSettings={sortingSettings}
      title={translate('OPS_PORTAL.TITLE.RECEIVABLES')}
      wrapTableInCard={false}
    />
  );
};
